import { FC } from "react";
import { useSectionNavigationContext } from "../section-navigation-context";
import { SectionNavigationAuxiliaryWrapperProps } from "./interfaces";

const SectionNavigationAuxiliaryWrapper: FC<SectionNavigationAuxiliaryWrapperProps> =
  ({ children, ...rest }) => {
    const { getAuxiliaryWrapperProps } = useSectionNavigationContext();

    if (!getAuxiliaryWrapperProps) {
      throw new Error(
        "SectionNavigation.AuxiliaryWrapper component requires getAuxiliaryWrapperProps to be defined",
      );
    }

    return <div {...getAuxiliaryWrapperProps({ ...rest })}>{children}</div>;
  };

export default SectionNavigationAuxiliaryWrapper;
